import engine from 'store/src/store-engine';
import sessionStorage from 'store/storages/sessionStorage';
import defaultPlugins from 'store/plugins/defaults';
export const sessionStore = engine.createStore([sessionStorage], [defaultPlugins])